module.exports = __webpack_public_path__ + "static/img/1-09.12923dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-09.png
// module id = 210
// module chunks = 0